function dispatchIfDifferentCallback(callback, store) {
    // Comparaison sur closeCallback (et non goBackCallback) : autrement, quand les
    // deux valent null, le dispatch etait saute et l'ancien callback de la page
    // precedente restait actif.
    if (store.state.layout.closeCallback === callback) {
        return;
    }
    store.dispatch('layout/setCloseCallback', callback);
}
export function setCloseCallback(callback, { store }) {
    if (!callback) {
        return dispatchIfDifferentCallback(null, store);
    }
    return dispatchIfDifferentCallback(callback, store);
}
